module.exports = __webpack_public_path__ + "static/img/chat.9a67f15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat.png
// module id = it8Z
// module chunks = 20